module.exports = __webpack_public_path__ + "img/icon_fb.e9af8240.svg";